import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { AppLayout } from '../../components/layouts/AppLayout'
import { RatingSummary, type RatingSummaryData } from '../../components/RatingSummary'
import { ReviewList } from '../../components/ReviewList'
import { Button } from '../../components/ui/button'
import {
  fetchFreightForwarderRatingSummary,
  fetchFreightForwarderReviews,
  type Review
} from '../../services/reviews'

export default function FreightForwarderProfilePage() {
  const { id } = useParams<{ id: string }>()
  const [summary, setSummary] = useState<RatingSummaryData | null>(null)
  const [reviews, setReviews] = useState<Review[]>([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [filter, setFilter] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)
  const pageSize = 10

  useEffect(() => {
    if (!id) return
    fetchFreightForwarderRatingSummary(id).then(setSummary).catch(console.error)
  }, [id])

  useEffect(() => {
    if (!id) return
    setLoading(true)
    fetchFreightForwarderReviews(id, { page, pageSize, rating: filter })
      .then((res) => {
        setReviews(res.items)
        setTotal(res.total)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [id, page, filter])

  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <AppLayout>
      <div className="max-w-4xl mx-auto px-4 py-6 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Reputação do agente</h1>
          {summary && (summary.completed_orders ?? 0) > 0 && (
            <p className="text-sm text-gray-600 mt-1">
              <strong className="text-emerald-700">{summary.completed_orders}</strong>{' '}
              {summary.completed_orders === 1 ? 'processo realizado' : 'processos realizados'} na plataforma
            </p>
          )}
        </div>

        {summary && (
          <RatingSummary
            data={summary}
            activeFilter={filter}
            onFilterByRating={(r) => {
              setFilter(r)
              setPage(1)
            }}
          />
        )}

        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <ReviewList items={reviews} loading={loading} />
          {totalPages > 1 && (
            <div className="mt-4 flex items-center justify-between text-sm">
              <Button
                variant="outline"
                size="sm"
                disabled={page <= 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Anterior
              </Button>
              <span className="text-gray-500">
                Página {page} de {totalPages}
              </span>
              <Button
                variant="outline"
                size="sm"
                disabled={page >= totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Próxima
              </Button>
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  )
}
